import React from "react";

export default function DecentralizeIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 7.75C6 5.67893 7.67893 4 9.75 4C11.8211 4 13.5 5.67893 13.5 7.75C13.5 9.82107 11.8211 11.5 9.75 11.5C7.67893 11.5 6 9.82107 6 7.75Z"
        fill="#A6B0CF"
      />
      <path
        d="M13.0994 4.38188C13.9645 5.24219 14.5 6.43355 14.5 7.75C14.5 9.06645 13.9645 10.2578 13.0994 11.1181C13.5974 11.3627 14.1577 11.5 14.75 11.5C16.8211 11.5 18.5 9.82107 18.5 7.75C18.5 5.67893 16.8211 4 14.75 4C14.1577 4 13.5974 4.13733 13.0994 4.38188Z"
        fill="#A6B0CF"
      />
      <path
        d="M3 16.75C3 14.6789 4.67893 13 6.75 13H12.75C14.8211 13 16.5 14.6789 16.5 16.75C16.5 18.8211 14.8211 20.5 12.75 20.5H6.75C4.67893 20.5 3 18.8211 3 16.75Z"
        fill="#A6B0CF"
      />
      <path
        d="M17.5 16.75C17.5 17.7749 17.1754 18.7239 16.6234 19.5H17.75C19.8211 19.5 21.5 17.8211 21.5 15.75C21.5 13.6789 19.8211 12 17.75 12H12.75C15.3734 12 17.5 14.1266 17.5 16.75Z"
        fill="#A6B0CF"
      />
    </svg>
  );
}
